<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
        ></dx-grid>
        <v-dialog v-model="approveDialog" max-width="490">
            <v-card class="pa-3">
                <v-card-title class="pl-0 py-0 headline mb-2"
                    >Kollel Application</v-card-title
                >

                <v-btn
                    v-if="clickedRow && clickedRow.documentURL"
                    small
                    class="mb-3"
                    @click="downloadDocument()"
                    style="height: 35px;"
                >
                    <v-icon color="red" left dark>mdi-file-pdf</v-icon>
                    <span class="mr-2">Kollel Application</span>
                    <v-icon right>mdi-download</v-icon>
                </v-btn>

                <v-btn
                    class="ml-0"
                    color="success"
                    small
                    @click="editApplication"
                    >Edit Application</v-btn
                >

                <div
                    class="pa-2"
                    style="overflow-y: auto; height: 400px; border: 2px solid #4caf50"
                >
                    <div
                        class="layout row mb-2 pa-0 mx-0"
                        v-for="prop in getRowProperties()"
                    >
                        <div class="font-weight-medium mr-1 width-200">
                            {{ prop.name }}:
                        </div>
                        <div>{{ prop.value }}</div>
                    </div>
                </div>

                <!-- <v-text-field
                    v-model="note"
                    label="Note"
                    v-if="clickedRow && clickedRow.status == 'SUBMITTED'"
                ></v-text-field> -->

                <v-textarea
                    v-model="note"
                    label="Note"
                    class="mt-3"
                    rows="2"
                    outline
                    hide-details
                ></v-textarea>
                <v-select
                    v-if="allowChangingStatus()"
                    v-model="status"
                    label="Status"
                    class="mt-2"
                    :items="[
                        'REJECTED',
                        'DELETED',
                        'IN PROCESS',
                        'APPROVED FULL KOLLEL',
                        'APPROVED KOLLEL WITH SIDE INCOME',
                    ]"
                    hide-details
                ></v-select>
                <v-textarea
                    v-if="allowChangingStatus() && status == 'REJECTED'"
                    v-model="rejectedReason"
                    class="mt-2"
                    rows="2"
                    label="Rejected Reason"
                    outline
                    hide-details
                ></v-textarea>
                <v-textarea
                    v-if="allowChangingStatus() && status == 'DELETED'"
                    v-model="deletedReason"
                    class="mt-2"
                    rows="2"
                    label="Deleted Reason"
                    outline
                    hide-details
                ></v-textarea>
                <v-card-actions class="mr-0 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="approveDialog = false"
                        >Close</v-btn
                    >
                    <v-btn color="success" :loading="processing" @click="save"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { toTitleCase, except } from "../../utils/helpers.js";

export default {
    data: () => ({
        title: "Kollel Applications",

        note: "",
        status: "",
        rejectedReason: "",
        deletedReason: "",
        approveDialog: false,
        processing: false,
        clickedRow: "",
        url: "",
        regID: "",

        actions: [],

        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value) => {
                    if (!value) return "mdi-flag-outline";

                    switch (value.trim()) {
                        case "SUBMITTED":
                            return "mdi-flag-outline";
                        case "IN PROCESS":
                            return "mdi-progress-upload";
                        case "REJECTED":
                            return "mdi-alert-circle";
                        case "DELETED":
                            return "mdi-close-circle";
                        case "APPROVED":
                        case "APPROVED FULL KOLLEL":
                        case "APPROVED KOLLEL WITH SIDE INCOME":
                            return "mdi-check-circle";
                        default:
                            return "mdi-flag-outline";
                    }
                },
                iconColor: (value) => {
                    if (!value) return "#fdb400";

                    switch (value.trim()) {
                        case "UPLOADED":
                            return "#aeb8bf";
                        case "SUBMITTED":
                            return "#fdb400";
                        case "IN PROCESS":
                            return "#42A5F5";
                        case "REJECTED":
                            return "#f35123";
                        case "DELETED":
                            return "#999";
                        case "APPROVED":
                        case "APPROVED FULL KOLLEL":
                        case "APPROVED KOLLEL WITH SIDE INCOME":
                            return "success";
                        default:
                            return "#fdb400";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "HomePhone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cellphone",
                field: "cellphone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Kollel Name",
                field: "kollelName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Kollel Address",
                field: "kollelAddress",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Kollel Time",
                field: "kollelTime",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Rosh Hakollel",
                field: "roshHakollel",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Kollel Name 2",
                field: "kollelName2",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Kollel Address2",
                field: "kollelAddress2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Kollel Time 2",
                field: "kollelTime2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Rosh Hakollel 2",
                field: "roshHakollel2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "On Kollel Payroll",
                field: "onKollelPayroll",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Side Job",
                field: "hasJob",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Side Job",
                field: "sideJob",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wife Has Job",
                field: "wifeHasJob",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wives Job",
                field: "wivesJob",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wives Position",
                field: "wivesPosition",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Wives Job Years",
                field: "wivesJobYears",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Source",
                field: "source",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Rejected Reason",
                field: "rejectedReason",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Deleted Reason",
                field: "deletedReason",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Application Document",
                field: "applicationDocument",
                template: "link-action-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "updatedBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated At",
                field: "updatedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: ">=",
            },
        ],
    }),
    async created() {
        this.columns.find(
            (c) => c.field == "applicationDocument",
        ).linkAction = (application) => {
            window.open(application.documentURL);
        };
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url = "kollelForms?regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/kollelForms/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/kollelForms/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;
            this.url = "kollelForms?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        onRowClicked(row) {
            this.clickedRow = row;
            this.note = row.note;
            this.status = row.status ? row.status : "SUBMITTED";
            this.rejectedReason = row.rejectedReason;
            this.deletedReason = row.deletedReason;

            this.approveDialog = true;
        },
        allowChangingStatus() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Kollel Admin");
        },
        getRowProperties() {
            if (!this.clickedRow) return [];

            return Object.keys(
                except(
                    this.clickedRow,
                    "vgt_id",
                    "originalIndex",
                    "vgtExpended",
                    "signature",
                    "applicationDocument",
                ),
            )
                .map((key) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == key);

                    if (!column) return { value: null };

                    const value =
                        ["date", "approvedAt", "updatedAt"].includes(key) &&
                        this.clickedRow[key]
                            ? this.formatTime(this.clickedRow[key])
                            : this.clickedRow[key];

                    return {
                        name: column ? column.label : toTitleCase(key),
                        value: value,
                    };
                })
                .filter((p) => p.value);
        },
        downloadDocument() {
            window.open(this.clickedRow.documentURL);
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        async save() {
            // this.$notify({
            //             text: "Please Select the Caller ID",
            //             group: "notification",
            //             type: "error",
            //         });

            // if (!this.status) {
            //     return this.$notify({
            //         text: "Please Select Status",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            if (this.status == "REJECTED" && !this.rejectedReason) {
                return this.$notify({
                    text: "Reason Is Required",
                    group: "notification",
                    type: "error",
                });
            }

            if (this.status == "DELETED" && !this.deletedReason) {
                return this.$notify({
                    text: "Reason Is Required",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/kollelForms/save", {
                    status: this.status,
                    rejectedReason:
                        this.status == "REJECTED" ? this.rejectedReason : "",
                    deletedReason:
                        this.status == "DELETED" ? this.deletedReason : "",
                    note: this.note,
                    user: this.$store.state.authentication.user,
                    accountID: this.clickedRow.accountID,
                    id: this.clickedRow.id,
                });

                this.processing = false;
                this.approveDialog = false;
                this.$refs.grid.reloadGrid();
            } catch (e) {
                console.log(e);

                this.processing = false;
            }
        },
        editApplication() {
            this.$router.push(
                "/kollel-application/" +
                    this.clickedRow.accountID +
                    (this.clickedRow.id ? "/" + this.clickedRow.id : ""),
            );
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
